import { alpha, Theme } from '@mui/material/styles';
export const getButton = (theme: Theme) => ({
  [theme.breakpoints.down('sm')]: { my: 3 },
  mt: 2,
  px: 3,
  minWidth: '100%',
  color: theme.palette.primary.main,
  backgroundImage: 'none',
  fontVariationSettings: "'wght' 500",
  [theme.breakpoints.up('lg')]: {
    minWidth: 'none'
  },
  '&:hover': {
    backgroundPosition: 'none',
    backgroundColor: alpha(theme.palette.primary.main, 0.1),
    transition: `background-color 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms, box-shadow 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms, border-color 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms, color 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms`,
    color: theme.palette.primary.main,
    boxShadow: 'none'
  }
});

export const connectWalletButtonStyles = (theme: Theme, isNavbar: boolean) => ({
  buttonConnect: {
    ...getButton(theme),
    mt: isNavbar ? 0 : 1.25,
    [theme.breakpoints.down('sm')]: { mb: 0, mt: 1 }
  }
});
